import { DEFAULT_LOCALE, LOCALES, type Locale, resources } from '@cabgo/i18n';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const STORAGE_KEY = 'cabgo.locale';

function storedLocale(): Locale {
  const v = typeof localStorage !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null;
  return LOCALES.includes(v as Locale) ? (v as Locale) : DEFAULT_LOCALE;
}

i18n.use(initReactI18next).init({
  resources,
  lng: storedLocale(),
  fallbackLng: DEFAULT_LOCALE,
  ns: [
    'common',
    'nav',
    'auth',
    'deletion',
    'settings',
    'trips',
    'dashboard',
    'passengers',
    'dispatchPolicy',
    'dispatch',
    'tracking',
    'reports',
    'drivers',
  ],
  defaultNS: 'common',
  interpolation: { escapeValue: false },
});

export function setLocale(locale: Locale) {
  localStorage.setItem(STORAGE_KEY, locale);
  i18n.changeLanguage(locale);
  document.documentElement.lang = locale;
}

export default i18n;
